import _ from 'lodash';

// Add props which wanted to be skipped as a case.
function skip(key) {
  switch (key) {
    case 'code':
    case 'id':
    case 'date':
    case 'outboundOperator':
    case 'outboundImpc':
    case 'inboundOperator':
    case 'inboundImpc':
    case 'rfidEdiRate':
    case 'dailyRouteLeadingCountStatus':
      return true;
    default:
      return false;
  }
}

export const getAvg = (data) => _.mergeWith({}, ...data, (a, b, key) => {
  if (skip(key)) {
    return;
  }
  if (_.isNumber(b)) {
    return ((b || 0) / data.length) + (_.isNumber(a) ? (a || 0) : 0);
  }
});

export const getTotal = (data) => _.mergeWith({}, ...data, (a, b, key) => {
  if (skip(key)) {
    return;
  }
  if (_.isNumber(b)) {
    return _.add(a, b);
  }
});
